import { Dispatch, MutableRefObject, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import PrintGridForm from '@/features/table-cards/form/PrintGridForm/PrintGridForm'
import Modal from '../Modal'

interface PrintGridModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  printRef: MutableRefObject<HTMLDivElement | null>
  setSelectedRowIds: Dispatch<SetStateAction<string[]>>
  setSelectedTableCards: Dispatch<SetStateAction<string[]>>
}

function PrintGridModal(props: PrintGridModalProps) {
  const {
    isOpen,
    setIsOpen,
    printRef,
    setSelectedRowIds,
    setSelectedTableCards
  } = props
  const { t } = useTranslation()
  const closeModal = () => {
    setIsOpen(false)
  }
  return (
    <Modal
      title={t('PRINT_GRID_MODAL.TITLE')}
      size="small"
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
    >
      <PrintGridForm
        printRef={printRef}
        setSelectedRowIds={setSelectedRowIds}
        setSelectedTableCards={setSelectedTableCards}
        closeModal={closeModal}
      />
    </Modal>
  )
}
export default PrintGridModal
